// Traducciones de /mcp (la página del servidor MCP). Los nombres propios (Claude, Cursor,
// Growth, Bison), los nombres de herramientas y las cifras se mantienen; cada entrada es
// [es, en, pt-BR]. Las claves deben coincidir exacto con el texto, espacios finales incluidos.
export const mcpMessages = Object.fromEntries(
  [
    // Compartidas con otras páginas (pie, /plataforma, /planes)
    ['Servidor MCP', 'MCP server', 'Servidor MCP'],
    ['Qué puedes preguntarle a tu asistente', 'What you can ask your assistant', 'O que você pode perguntar ao seu assistente'],
    ['Plan Growth', 'Growth plan', 'Plano Growth'],
    ['Tus datos', 'Your data', 'Seus dados'],
    ['Cada semana', 'Every week', 'Toda semana'],
    ['Prioridades', 'Priorities', 'Prioridades'],
    ['Tráfico', 'Traffic', 'Tráfego'],
    ['Medición', 'Measurement', 'Medição'],
    ['Fuentes', 'Sources', 'Fontes'],
    ['Demo', 'Demo', 'Demonstração'],

    // Hero
    ['SERVIDOR MCP', 'MCP SERVER', 'SERVIDOR MCP'],
    ['Tu asistente de IA · Tus datos de Bison', 'Your AI assistant · Your Bison data', 'Seu assistente de IA · Seus dados do Bison'],
    ['Pregúntale a tu asistente ', 'Ask your assistant ', 'Pergunte ao seu assistente '],
    ['cómo te ve la IA.', 'how AI sees you.', 'como a IA enxerga você.'],
    [
      'Conecta Claude, Cursor, VS Code u otro cliente MCP a Bison y consulta la visibilidad de tu marca en lenguaje natural, con las mismas cifras de tu dashboard.',
      'Connect Claude, Cursor, VS Code or another MCP client to Bison and check your brand’s visibility in plain language, with the same figures as your dashboard.',
      'Conecte Claude, Cursor, VS Code ou outro cliente MCP ao Bison e consulte a visibilidade da sua marca em linguagem natural, com os mesmos números do seu dashboard.',
    ],
    ['Disponible en', 'Available on', 'Disponível no'],
    ['Junto al agente del dashboard', 'Alongside the dashboard agent', 'Junto ao agente do dashboard'],
    ['Funciona con', 'Works with', 'Funciona com'],
    ['6 clientes MCP', '6 MCP clients', '6 clientes MCP'],
    ['Claude Code, Cursor, VS Code y más', 'Claude Code, Cursor, VS Code and more', 'Claude Code, Cursor, VS Code e mais'],
    ['Qué ofrece', 'What it offers', 'O que oferece'],
    ['34 herramientas', '34 tools', '34 ferramentas'],
    ['3 flujos listos y 4 recursos', '3 ready-made flows and 4 resources', '3 fluxos prontos e 4 recursos'],
    ['Permisos', 'Permissions', 'Permissões'],
    ['Lectura o edición', 'Read or edit', 'Leitura ou edição'],
    ['Tú eliges en cada token', 'You choose for each token', 'Você escolhe em cada token'],

    // 01 Qué preguntarle
    ['01 / Qué preguntarle', '01 / What to ask', '01 / O que perguntar'],
    ['Pregunta como se lo pedirías ', 'Ask the way you’d ask ', 'Pergunte como você pediria '],
    ['a tu equipo.', 'your team.', 'à sua equipe.'],
    [
      'Ejemplos que puedes pegar tal cual. Tu asistente elige la herramienta y responde con los datos de tu marca; abajo de cada uno ves cuál usa.',
      'Examples you can paste as they are. Your assistant picks the tool and answers with your brand’s data; under each one you can see which tool it uses.',
      'Exemplos que você pode colar como estão. Seu assistente escolhe a ferramenta e responde com os dados da sua marca; abaixo de cada um você vê qual ela usa.',
    ],
    ['Usa', 'Uses', 'Usa'],
    ['· con permiso de edición', '· with edit permission', '· com permissão de edição'],
    ['Cómo aparece tu marca', 'How your brand shows up', 'Como sua marca aparece'],
    [
      'El resumen de la semana y la tendencia, sin abrir el dashboard.',
      'The week’s summary and the trend, without opening the dashboard.',
      'O resumo da semana e a tendência, sem abrir o dashboard.',
    ],
    [
      '¿Cómo estuvo mi visibilidad en IA esta semana? Dame el puntaje general, la tasa de mención y qué cambió contra la semana anterior.',
      'How was my AI visibility this week? Give me the overall score, the mention rate and what changed from the previous week.',
      'Como foi minha visibilidade em IA esta semana? Me dê a pontuação geral, a taxa de menção e o que mudou em relação à semana anterior.',
    ],
    [
      'Muéstrame cómo ha evolucionado mi visibilidad en los últimos seis meses, por modelo.',
      'Show me how my visibility has evolved over the last six months, by model.',
      'Mostre como minha visibilidade evoluiu nos últimos seis meses, por modelo.',
    ],
    ['Por qué cambió', 'Why it changed', 'Por que mudou'],
    [
      'Cuando una cifra baja, la causa: qué pregunta, qué modelo, qué competidor.',
      'When a number drops, the cause: which question, which model, which competitor.',
      'Quando um número cai, a causa: qual pergunta, qual modelo, qual concorrente.',
    ],
    ['Investiga por qué bajó mi visibilidad en ChatGPT.', 'Find out why my visibility dropped in ChatGPT.', 'Investigue por que minha visibilidade caiu no ChatGPT.'],
    [
      'Compara la última semana medida con la de hace un mes. ¿Qué preguntas subieron y cuáles bajaron?',
      'Compare the last measured week with the one a month ago. Which questions went up and which went down?',
      'Compare a última semana medida com a de um mês atrás. Quais perguntas subiram e quais caíram?',
    ],
    ['Frente a tu competencia', 'Against your competitors', 'Frente à sua concorrência'],
    [
      'Quién aparece más que tú y qué fuentes lo sostienen.',
      'Who shows up more than you and which sources back them.',
      'Quem aparece mais do que você e quais fontes sustentam isso.',
    ],
    [
      '¿Qué competidor aparece más que yo y en qué modelo?',
      'Which competitor shows up more than me, and in which model?',
      'Qual concorrente aparece mais do que eu e em qual modelo?',
    ],
    [
      '¿Qué páginas citan más los modelos al responder mis preguntas y qué marcas aparecen en ellas?',
      'Which pages do the models cite most when answering my questions, and which brands appear on them?',
      'Quais páginas os modelos mais citam ao responder minhas perguntas e quais marcas aparecem nelas?',
    ],
    ['Qué mejorar primero', 'What to improve first', 'O que melhorar primeiro'],
    [
      'Las mejoras ordenadas por impacto y el detalle para quien las ejecuta.',
      'Improvements ranked by impact, with the detail for whoever carries them out.',
      'As melhorias ordenadas por impacto e o detalhe para quem as executa.',
    ],
    [
      'Dame las tres mejoras con más impacto y el brief de la primera.',
      'Give me the three highest-impact improvements and the brief for the first one.',
      'Me dê as três melhorias de maior impacto e o brief da primeira.',
    ],
    [
      'Marca como hecha la mejora que acabamos de revisar y sus dos primeros pasos.',
      'Mark the improvement we just reviewed as done, along with its first two steps.',
      'Marque como concluída a melhoria que acabamos de revisar e seus dois primeiros passos.',
    ],
    ['Tus preguntas monitoreadas', 'Your monitored questions', 'Suas perguntas monitoradas'],
    [
      'Sumar, sugerir o archivar preguntas sin salir de la conversación.',
      'Add, suggest or archive questions without leaving the conversation.',
      'Adicionar, sugerir ou arquivar perguntas sem sair da conversa.',
    ],
    [
      'Muéstrame las preguntas sugeridas y dime cuáles conviene agregar.',
      'Show me the suggested questions and tell me which ones are worth adding.',
      'Mostre as perguntas sugeridas e diga quais vale a pena adicionar.',
    ],
    [
      'Agrega al monitoreo la pregunta “¿Cuál es el mejor software de facturación para pymes?”. Muéstrame antes cuántos cupos me quedan.',
      'Add the question “What is the best invoicing software for small businesses?” to monitoring. Show me first how many slots I have left.',
      'Adicione ao monitoramento a pergunta “Qual é o melhor software de faturamento para pequenas empresas?”. Antes, mostre quantas vagas me restam.',
    ],
    ['Tu sitio', 'Your website', 'Seu site'],
    [
      'El estado técnico del sitio y el tráfico que llega desde la IA.',
      'Your site’s technical health and the traffic that arrives from AI.',
      'O estado técnico do site e o tráfego que chega da IA.',
    ],
    [
      '¿Qué problemas técnicos de mi sitio afectan a los rastreadores de IA?',
      'Which technical issues on my site affect AI crawlers?',
      'Quais problemas técnicos do meu site afetam os rastreadores de IA?',
    ],
    [
      '¿Cuántas sesiones llegan a mi sitio desde asistentes de IA y cuántas terminan en conversión?',
      'How many sessions reach my site from AI assistants, and how many end in a conversion?',
      'Quantas sessões chegam ao meu site vindas de assistentes de IA e quantas terminam em conversão?',
    ],

    // 02 Qué trae el servidor
    ['02 / Qué trae el servidor', '02 / What the server includes', '02 / O que o servidor traz'],
    ['Tres flujos listos y ', 'Three ready-made flows and ', 'Três fluxos prontos e '],
    ['34 herramientas.', '34 tools.', '34 ferramentas.'],
    [
      'Los flujos se eligen desde el menú de tu cliente y encadenan las herramientas por ti. Si prefieres preguntar a tu manera, tu asistente usa las herramientas directamente.',
      'You pick the flows from your client’s menu and they chain the tools for you. If you’d rather ask your own way, your assistant uses the tools directly.',
      'Os fluxos são escolhidos no menu do seu cliente e encadeiam as ferramentas por você. Se preferir perguntar do seu jeito, seu assistente usa as ferramentas diretamente.',
    ],
    ['Revisión semanal', 'Weekly review', 'Revisão semanal'],
    [
      'Qué cambió en la semana, por qué, y las tres acciones que más importan.',
      'What changed during the week, why, and the three actions that matter most.',
      'O que mudou na semana, por quê, e as três ações que mais importam.',
    ],
    ['Sin argumentos', 'No arguments', 'Sem argumentos'],
    ['Explicar una caída', 'Explain a drop', 'Explicar uma queda'],
    [
      'Investiga por qué bajó la visibilidad: en general, en un modelo o en una pregunta.',
      'Finds out why visibility dropped: overall, in one model or in one question.',
      'Investiga por que a visibilidade caiu: no geral, em um modelo ou em uma pergunta.',
    ],
    ['foco, opcional: un modelo o una pregunta', 'foco, optional: a model or a question', 'foco, opcional: um modelo ou uma pergunta'],
    ['Brief de un competidor', 'Competitor brief', 'Brief de um concorrente'],
    [
      'Qué hace un competidor para aparecer en las respuestas de IA y cómo responder.',
      'What a competitor does to show up in AI answers, and how to respond.',
      'O que um concorrente faz para aparecer nas respostas de IA e como responder.',
    ],
    ['competidor: su dominio o su nombre', 'competidor: its domain or its name', 'competidor: seu domínio ou seu nome'],
    ['Herramientas por área', 'Tools by area', 'Ferramentas por área'],
    ['con permiso de edición', 'with edit permission', 'com permissão de edição'],
    ['Visibilidad', 'Visibility', 'Visibilidade'],
    ['Competencia', 'Competition', 'Concorrência'],
    ['Preguntas monitoreadas', 'Monitored questions', 'Perguntas monitoradas'],
    ['Mejoras', 'Improvements', 'Melhorias'],
    ['Reportes y sitio', 'Reports and website', 'Relatórios e site'],
    ['Perfil de marca', 'Brand profile', 'Perfil da marca'],
    ['Recursos para adjuntar', 'Resources to attach', 'Recursos para anexar'],
    [
      'Documentos que tu asistente toma como contexto sin llamar una herramienta.',
      'Documents your assistant takes as context without calling a tool.',
      'Documentos que seu assistente usa como contexto sem chamar uma ferramenta.',
    ],
    ['Visibilidad de la última semana', 'Last week’s visibility', 'Visibilidade da última semana'],
    ['Último reporte mensual', 'Latest monthly report', 'Último relatório mensal'],
    ['Auditoría técnica', 'Technical audit', 'Auditoria técnica'],

    // 03 Permisos y seguridad
    ['03 / Permisos y seguridad', '03 / Permissions and security', '03 / Permissões e segurança'],
    ['Tú decides ', 'You decide ', 'Você decide '],
    ['qué puede hacer.', 'what it can do.', 'o que ele pode fazer.'],
    [
      'Cada conexión usa un token que creas en Bison, con permiso de solo lectura o de lectura y edición. Con solo lectura, tu asistente consulta y no cambia nada.',
      'Each connection uses a token you create in Bison, with read-only or read-and-edit permission. With read-only, your assistant looks things up and changes nothing.',
      'Cada conexão usa um token que você cria no Bison, com permissão somente de leitura ou de leitura e edição. Com somente leitura, seu assistente consulta e não altera nada.',
    ],
    ['Qué permite cada tipo de token', 'What each type of token allows', 'O que cada tipo de token permite'],
    ['Solo lectura', 'Read-only', 'Somente leitura'],
    ['Lectura y edición', 'Read and edit', 'Leitura e edição'],
    ['20 herramientas', '20 tools', '20 ferramentas'],
    [
      'Consultar visibilidad, tendencia y tráfico desde IA',
      'Check visibility, trend and traffic from AI',
      'Consultar visibilidade, tendência e tráfego vindo da IA',
    ],
    [
      'Ver competidores, fuentes citadas y preguntas monitoreadas',
      'See competitors, cited sources and monitored questions',
      'Ver concorrentes, fontes citadas e perguntas monitoradas',
    ],
    [
      'Leer mejoras, auditorías y reportes mensuales',
      'Read improvements, audits and monthly reports',
      'Ler melhorias, auditorias e relatórios mensais',
    ],
    [
      'Completar el perfil de marca, sus productos y audiencias',
      'Complete the brand profile, its products and audiences',
      'Completar o perfil da marca, seus produtos e públicos',
    ],
    ['Crear, archivar o aceptar preguntas', 'Create, archive or accept questions', 'Criar, arquivar ou aceitar perguntas'],
    ['Dentro del cupo de tu plan', 'Within your plan’s quota', 'Dentro da cota do seu plano'],
    ['Guardar competidores', 'Save competitors', 'Salvar concorrentes'],
    ['Marcar mejoras como hechas', 'Mark improvements as done', 'Marcar melhorias como concluídas'],
    ['Lanzar una auditoría de schema', 'Run a schema audit', 'Iniciar uma auditoria de schema'],
    ['Tiene costo: hasta 5 por día', 'Has a cost: up to 5 per day', 'Tem custo: até 5 por dia'],
    ['Solo tu empresa', 'Only your company', 'Só a sua empresa'],
    [
      'Cada token lee únicamente los datos de la empresa que lo creó, con las mismas cifras de su dashboard.',
      'Each token reads only the data of the company that created it, with the same figures as its dashboard.',
      'Cada token lê apenas os dados da empresa que o criou, com os mesmos números do seu dashboard.',
    ],
    ['Vista previa antes de guardar', 'Preview before saving', 'Prévia antes de salvar'],
    [
      'Un cambio muestra primero el antes y el después, y se guarda solo cuando lo confirmas.',
      'A change first shows the before and after, and is saved only when you confirm it.',
      'Uma alteração mostra primeiro o antes e o depois, e só é salva quando você confirma.',
    ],
    ['Quién crea los tokens', 'Who creates tokens', 'Quem cria os tokens'],
    [
      'Solo dueños y administradores. El token se muestra una vez y Bison guarda solo una huella.',
      'Only owners and admins. The token is shown once and Bison keeps only a fingerprint.',
      'Somente donos e administradores. O token é exibido uma vez e o Bison guarda apenas uma impressão digital.',
    ],
    ['Revocas cuando quieras', 'Revoke whenever you want', 'Revogue quando quiser'],
    [
      'Hasta 10 tokens activos por empresa. Uno revocado deja de funcionar en ese momento.',
      'Up to 10 active tokens per company. A revoked token stops working right away.',
      'Até 10 tokens ativos por empresa. Um token revogado deixa de funcionar na hora.',
    ],

    // 04 Cómo conectarlo
    ['04 / Cómo conectarlo', '04 / How to connect it', '04 / Como conectar'],
    ['Un token, tu cliente ', 'A token, your client ', 'Um token, seu cliente '],
    ['y listo.', 'and you’re set.', 'e pronto.'],
    ['Crea un token', 'Create a token', 'Crie um token'],
    [
      'En Bison, en Ajustes → API y agentes. Elige solo lectura o lectura y edición.',
      'In Bison, under Settings → API and agents. Choose read-only or read and edit.',
      'No Bison, em Configurações → API e agentes. Escolha somente leitura ou leitura e edição.',
    ],
    ['Conecta tu cliente', 'Connect your client', 'Conecte seu cliente'],
    [
      'Claude Code y Gemini CLI se conectan con un comando; Cursor, VS Code, Claude Desktop y Codex, con unas líneas de configuración.',
      'Claude Code and Gemini CLI connect with one command; Cursor, VS Code, Claude Desktop and Codex, with a few lines of configuration.',
      'Claude Code e Gemini CLI se conectam com um comando; Cursor, VS Code, Claude Desktop e Codex, com algumas linhas de configuração.',
    ],
    ['Comprueba y pregunta', 'Check and ask', 'Confira e pergunte'],
    [
      'Pide «Lista las herramientas del MCP de Bison»: con solo lectura verás 20 y con edición, 34. Después, tu primera pregunta.',
      'Ask “List the Bison MCP tools”: with read-only you’ll see 20, and with edit, 34. Then, your first question.',
      'Peça “Liste as ferramentas do MCP do Bison”: com somente leitura você verá 20 e com edição, 34. Depois, sua primeira pergunta.',
    ],
    [
      'ChatGPT todavía no: sus conectores personalizados solo aceptan OAuth, que Bison aún no ofrece.',
      'Not ChatGPT yet: its custom connectors only accept OAuth, which Bison doesn’t offer yet.',
      'ChatGPT ainda não: seus conectores personalizados só aceitam OAuth, que o Bison ainda não oferece.',
    ],
    [
      'La configuración de cada cliente, paso a paso. ',
      'The setup for each client, step by step. ',
      'A configuração de cada cliente, passo a passo. ',
    ],
    ['Ver la guía de conexión', 'See the connection guide', 'Ver o guia de conexão'],
    [
      'Pega el comando en tu terminal con tu token en lugar de bsn_TU_TOKEN y pídele a tu asistente que liste las herramientas de Bison.',
      'Paste the command into your terminal with your token in place of bsn_TU_TOKEN and ask your assistant to list the Bison tools.',
      'Cole o comando no seu terminal com seu token no lugar de bsn_TU_TOKEN e peça ao seu assistente que liste as ferramentas do Bison.',
    ],

    // 05 Dudas frecuentes
    ['05 / Dudas frecuentes', '05 / Frequently asked questions', '05 / Dúvidas frequentes'],
    ['Lo que se pregunta ', 'What people ask ', 'O que se pergunta '],
    ['antes de conectarlo.', 'before connecting it.', 'antes de conectá-lo.'],
    [
      'Los parámetros, límites y errores de cada herramienta están en la documentación técnica.',
      'The parameters, limits and errors of each tool are in the technical documentation.',
      'Os parâmetros, limites e erros de cada ferramenta estão na documentação técnica.',
    ],
    ['¿Qué es el servidor MCP de Bison?', 'What is the Bison MCP server?', 'O que é o servidor MCP do Bison?'],
    [
      'Es la conexión que deja a tu asistente de IA consultar tus datos de Bison y responderte en lenguaje natural. Le preguntas cómo le fue a tu marca en ChatGPT, Gemini, Perplexity y Claude, por qué bajó o qué conviene arreglar primero, sin entrar al dashboard ni exportar planillas.',
      'It’s the connection that lets your AI assistant look up your Bison data and answer you in plain language. You ask how your brand did in ChatGPT, Gemini, Perplexity and Claude, why it dropped or what to fix first, without opening the dashboard or exporting spreadsheets.',
      'É a conexão que permite ao seu assistente de IA consultar seus dados do Bison e responder em linguagem natural. Você pergunta como sua marca se saiu no ChatGPT, Gemini, Perplexity e Claude, por que caiu ou o que convém corrigir primeiro, sem entrar no dashboard nem exportar planilhas.',
    ],
    ['¿Con qué asistentes funciona?', 'Which assistants does it work with?', 'Com quais assistentes funciona?'],
    [
      'Con Claude Code, Cursor, VS Code, Claude Desktop, Gemini CLI y Codex, y con otros clientes compatibles con el Model Context Protocol que permitan enviar un token. ChatGPT todavía no: sus conectores personalizados solo aceptan OAuth, que Bison aún no ofrece.',
      'With Claude Code, Cursor, VS Code, Claude Desktop, Gemini CLI and Codex, and with other Model Context Protocol clients that let you send a token. Not ChatGPT yet: its custom connectors only accept OAuth, which Bison doesn’t offer yet.',
      'Com Claude Code, Cursor, VS Code, Claude Desktop, Gemini CLI e Codex, e com outros clientes compatíveis com o Model Context Protocol que permitam enviar um token. ChatGPT ainda não: seus conectores personalizados só aceitam OAuth, que o Bison ainda não oferece.',
    ],
    ['¿Qué datos puede ver mi asistente?', 'What data can my assistant see?', 'Quais dados meu assistente pode ver?'],
    [
      'Solo los de tu empresa: el perfil de marca, la visibilidad por semana y por modelo, los competidores, las preguntas monitoreadas, las fuentes citadas, las mejoras, las auditorías y los reportes. Son las mismas cifras de tu dashboard; el servidor no calcula otras. Cuando falta un dato lo dice: un valor vacío significa sin datos, no cero.',
      'Only your company’s: the brand profile, visibility by week and by model, competitors, monitored questions, cited sources, improvements, audits and reports. They’re the same figures as your dashboard; the server doesn’t calculate different ones. When data is missing it says so: an empty value means no data, not zero.',
      'Somente os da sua empresa: o perfil da marca, a visibilidade por semana e por modelo, os concorrentes, as perguntas monitoradas, as fontes citadas, as melhorias, as auditorias e os relatórios. São os mesmos números do seu dashboard; o servidor não calcula outros. Quando falta um dado, ele avisa: um valor vazio significa sem dados, não zero.',
    ],
    ['¿Puede cambiar algo en mi cuenta?', 'Can it change anything in my account?', 'Ele pode alterar algo na minha conta?'],
    [
      'Solo con un token de lectura y edición. Con ese permiso puede completar el perfil de marca, crear o archivar preguntas, guardar competidores y marcar mejoras como hechas. Cada cambio muestra primero una vista previa con el antes y el después, y se guarda cuando lo confirmas. Con un token de solo lectura no cambia nada.',
      'Only with a read-and-edit token. With that permission it can complete the brand profile, create or archive questions, save competitors and mark improvements as done. Each change first shows a preview with the before and after, and is saved when you confirm it. With a read-only token it changes nothing.',
      'Somente com um token de leitura e edição. Com essa permissão ele pode completar o perfil da marca, criar ou arquivar perguntas, salvar concorrentes e marcar melhorias como concluídas. Cada alteração mostra primeiro uma prévia com o antes e o depois, e é salva quando você confirma. Com um token somente de leitura, não altera nada.',
    ],
    ['¿En qué plan está disponible?', 'Which plan includes it?', 'Em qual plano está disponível?'],
    [
      'En el plan Growth, junto al agente integrado del dashboard. Puedes ver lo que incluye cada plan en la página de planes.',
      'In the Growth plan, alongside the integrated dashboard agent. You can see what each plan includes on the plans page.',
      'No plano Growth, junto ao agente integrado do dashboard. Você pode ver o que cada plano inclui na página de planos.',
    ],
    ['¿Es lo mismo que el agente del dashboard?', 'Is it the same as the dashboard agent?', 'É o mesmo que o agente do dashboard?'],
    [
      'No. El agente vive dentro de Bison y responde en el dashboard; el servidor MCP lleva los mismos datos a tu propio asistente, donde tu equipo ya trabaja.',
      'No. The agent lives inside Bison and answers in the dashboard; the MCP server takes the same data to your own assistant, where your team already works.',
      'Não. O agente vive dentro do Bison e responde no dashboard; o servidor MCP leva os mesmos dados ao seu próprio assistente, onde sua equipe já trabalha.',
    ],

    // Llamado final
    ['Tu marca, ', 'Your brand, ', 'Sua marca, '],
    ['a una pregunta de distancia.', 'one question away.', 'a uma pergunta de distância.'],
  ].map(([es, en, pt]) => [es, [en, pt]])
);
